<template>
	<div :class="[pageType === 'modal' ? 'p-3' : '', 'h-100']">
		<span class="text-red" v-if="attachments.length == 0">{{ $t('trs.related-factor-attachments.no-attachment') }}</span>
		<div v-if="attachments.length == 0" :class="[attachments.length == 0 ? 'mr-2' : 'mr-0', 'mb-2 d-inline']">
			<nk-button :tabindex="tabindex + 1" class="" :options="btnAdd" @click="addAttachment"></nk-button>
		</div>
		<div>
			<ag-grid style="height:250px;" v-if="attachments.length > 0" :options="componentOptions.tableOptions" :data="attachments" @preSelectedRowData="(data) => selectedRow = data" :tabindex="tabindex + 4" ref="table" startup></ag-grid>

		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import $sc from '~/plugins/shortcut.collection.js'
	import FactorAttachmentsModify from '~/components/form/related-factor-attachments/related-factor-attachments-modify'
	import { isEmpty } from '~/statics/validators'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import emptyId from '~/statics/empty-id'
	import SourcePreviewLabel from '~/components/general/source-preview-label.vue'

	export default {
		name: 'related-factor-attachments',
		modal: {
			size: 'sm',
			stateUID: 'related-factor-attachments',
		},
		props: {
			options: {},
			tabindex: {}
		},
		data() {
			return {
				selectButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					icon: 'save',
					isPrimary: true,
					visible: true,
					disabled: false,
					handle: (button, page, e) => {
						const rows = this.$refs.table.getData()
						this.resolve(rows.map(x => {
							x.id = emptyId
							return x
						}))
					}
				},
				pageType: 'tab',
				settings: {
					transaction: {
						id: emptyId
					},
					targetForm: '', // payment receive transfer
					filterFloatingCenterIds: [],
				},
				btnAdd: {
					title: this.$t('trs.related-factor-attachments.add-attachment'),
					isPrimary: false,
					icon: 'plus'
				},
				btnEdit: {
					title: this.$t('edit'),
					isPrimary: false,
					icon: 'edit'
				},
				btnDelete: {
					title: this.$t('delete'),
					icon: 'trash',
					isDanger: true
				},
				componentOptions: {
					tableOptions: {
						id: this.$options.name,
						rowGroupPanelShow: false,
						groupIncludeTotalFooter: true,
						cellSelectionAggReport: false,
						sideBar: 'none',
						rowSelection: {
							mode: 'singleRow'
						},
						fitToWidth: false,
						buttons: {
							addBtn: {
								handler: this.addAttachment,
								options: {
									visible: true,
								},
							},
							deleteBtn: {
								handler: this.deleteAttachment,
								options: {
									// visible: this.attachments.length > 0,
									visible: true,
								},
							},
							editBtn: {
								handler: this.editAttachment,
								displayOrder: 2,
								class: "no-outline",
								type: 'nk-btn',
								options: {
									visible: true,
									isPrimary: false,
									hideShortcut: true,
									title: this.$t('edit'),
									visible: true,
									icon: 'edit',
									tooltipEnabled: true,
									hideTitle: true,
								}
							},
						},

						columnDefs: [
							{
								field: 'rowNumber',
								headerName: this.$t('row-number'),
								width: 80,
								// suppressSizeToFit:true,
								// maxWidth:80,
							},
							{
								field: 'factorHeader',
								headerName: this.$t('sale.factor.f.code'),
								contentType: 'enum',
								width: 300,
								valueFormatter: data => {
									return data?.value && `${this.$t(`sale.factor.types.${data.value.type}`)} - ${this.$t('sale.factor.f.code')}: ${data.value.code}`
								},
								cellRenderer: SourcePreviewLabel,
								cellRendererParams: (params) => {
									return params.value && {
										options: {
											entityType: `Factor_${params.data.factorHeader.type}`,
											entityId: params.data.factorHeader.id,
											format: (item) => item && `${this.$t(`sale.factor.types.${item.type}`)} - ${this.$t('sale.factor.f.code')}: ${item.code}`,
											style: {
												color: params.data.isSelected ? 'white' : '#5c53c5'
											}
										}
									}
								},
							},
							{
								field: 'entityAttachedAmount',
								headerName: this.$t('sale.factor-attachments.f.entityAttachedAmount'),
								contentType: 'price',
								aggFunc: 'sum',
								width: 100
							}


						],

						// editable: false,
						// searchable: false,
						// addNewRowOnInit: false,
						// alwaysEmit: true,
						// prepareNewRow: () => {
						// 	return {
						// 		factor: {},
						// 		attachedAmount: 0
						// 	}
						// },
						// buttons: {
						// 	addBtn: {
						// 		handler: this.addAttachment,
						// 		options: {
						// 			visible: true,
						// 		},
						// 	},
						// 	deleteBtn: {
						// 		handler: this.deleteAttachment,
						// 		options: {
						// 			// visible: this.attachments.length > 0,
						// 			visible: true,
						// 		},
						// 	},
						// 	editBtn: {
						// 		handler: this.editAttachment,
						// 		displayOrder: 2,
						// 		class: "no-outline",
						// 		type: 'nk-btn',
						// 		options: {
						// 			visible: true,
						// 			isPrimary: false,
						// 			hideShortcut: true,
						// 			title: this.$t('edit'),
						// 			visible: true,
						// 			icon: 'edit',
						// 			tooltipEnabled: true,
						// 			hideTitle: true,
						// 		}
						// 	},
						// },
						// columns: [
						// 	{
						// 		name: 'rowNumber',
						// 		title: this.$t('row-number'),
						// 		pinned: false,
						// 		pinnable: false,
						// 		width: '50px',
						// 		entering: false
						// 	},
						// 	{
						// 		name: 'factorHeader',
						// 		title: this.$t('sale.factor.f.code'),
						// 		editable: true,
						// 		pinnable: false,
						// 		type: 'number',
						// 		searchable: true,
						// 		search: {
						// 			searchFields: ['code']
						// 		},
						// 		width: '250px | >450px',
						// 		view: (row, col) => {
						// 			return {
						// 				component: SourcePreviewLabel,
						// 				options: {
						// 					entityType: `Factor_${row.factorHeader.type}`,
						// 					entityId: row.factorHeader.id,
						// 					format: (item) => `${this.$t(`sale.factor.types.${item.type}`)} - ${this.$t('sale.factor.f.code')}: ${item.code}`,
						// 					style: {
						// 						color: row.isSelected ? 'white' : '#5c53c5'
						// 					}
						// 				}
						// 			}
						// 		},
						// 		edit: (row, col) => {
						// 			return {
						// 				component: Dropdown,
						// 				options: {
						// 					rowIdentifier: 'id',
						// 					searchable: true,
						// 					required: true,
						// 					remoteSearch: false,
						// 					placeholder: this.$t('search-it'),
						// 					display: (item) => {
						// 						if (!item)
						// 							return 'aaa'
						// 						return `${this.$t(`sale.factor.types.${item.type}`)} - ${this.$t('sale.factor.f.code')}: ${item.code}`
						// 					},
						// 					searchableFields: ['code'],
						// 					selectorWidth: '400px',
						// 					component: {
						// 						type: Table,
						// 						options: {
						// 							editable: false,
						// 							activeRowDisabled: true,
						// 							alwaysEmit: false,
						// 							columns: [
						// 								{
						// 									name: 'code',
						// 									title: this.$t('center.selector.table.c.accountingCode'),
						// 									width: '70px|>70px',
						// 									pinnable: false
						// 								},
						// 								{
						// 									name: 'name',
						// 									title: this.$t('center.selector.table.c.name'),
						// 									width: 'auto',
						// 									pinnable: false
						// 								}
						// 							]
						// 						}
						// 					},
						// 					buttons: [{
						// 						title: this.$t('select'),
						// 						shortcut: $sc.find('enter'),
						// 						isPrimary: true,
						// 						icon: 'plus',
						// 						handle: (button, page, e) => {
						// 							this.attachableFactorList(row)
						// 						}
						// 					}]
						// 				}
						// 			}
						// 		}
						// 	},
						// 	{
						// 		name: 'entityAttachedAmount',
						// 		title: this.$t('sale.factor-attachments.f.entityAttachedAmount'),
						// 		editable: true,
						// 		pinnable: false,
						// 		type: 'price',
						// 		search: {
						// 			searchFields: ['entityAttachedAmount']
						// 		},
						// 		aggregates: [
						// 			{
						// 				type: 'sum',
						// 			}
						// 		],
						// 		view: {
						// 			options: {
						// 				type: 'price'
						// 			}
						// 		},
						// 		edit: {
						// 			component: Input,
						// 			options: {
						// 				mode: 'price'
						// 			}
						// 		},
						// 		width: '200px',
						// 		entering: true
						// 	}
						// ]
					}
				},
				attachments: [],
				selectedRow: null
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.settings = _.extend({}, this.settings, val)
					if (val && oldVal && oldVal.transaction?.id !== val.transaction?.id)
						this.loadAttachments()
				}
			},
		},
		created() {

		},
		mounted() {
			this.pageType = this.grandParentType()
			if (this.pageType === 'modal')
				this.prepareWindow(this.$t('trs.related-factor-attachments.attachments-management'), [this.selectButton])

		},
		methods: {
			addAttachment(button, e) {
				e.preventDefault()

				if (this.settings.targetForm !== 'transfer')
					this.settings.transaction.amount = this.settings.transaction.currencyValues[0].debit

				var options = {
					mode: 'select',
					targetForm: this.settings.targetForm,
					attachments: this.attachments,
					filterFloatingCenterIds: this.settings.filterFloatingCenterIds
				}
				var data = {
					transaction: this.settings.transaction,
					factorHeader: {},
					entityAttachedAmount: 0,
					id: 'emptyId' + this.idGenerator(5),
					temp: { init: 0, changes: 0 }
				}
				this.showModal({ component: FactorAttachmentsModify, data: data, options })
					.then((result) => {
						if (result) {
							result.temp.changes = result.entityAttachedAmount
							result.rowState = 'new'
							result.entityDescription = ''
							result.entityId = this.settings.transaction.id
							result.entityTotalAmount = this.settings.transaction.amount
							result.entityType = 'Transaction'
							result.factorHeaderId = result.factorHeader.id
							result.isInitial = false
							this.attachments.push(result)
						}
					})
					.catch(() => {
						if (this.$refs.table)
							this.$refs.table.$el.focus()
					})
			},
			editAttachment(button, e) {
				e.preventDefault()
				if (!this.selectedRow)
					return this.$toast(this.$t('document.m.select-row'))

				var options = {
					mode: 'select',
					targetForm: this.settings.targetForm,
					attachments: this.attachments
				}
				var data = {
					transaction: this.settings.transaction,
					factorHeader: this.selectedRow.factorHeader,
					entityAttachedAmount: this.selectedRow.entityAttachedAmount,
					id: this.selectedRow.id,
					temp: this.selectedRow.temp
				}

				this.showModal({ component: FactorAttachmentsModify, data: data, options })
					.then((result) => {
						if (result) {
							result.temp.changes = result.entityAttachedAmount - this.attachments[this.selectedRow.displayOrder].temp.init
							result.rowState = result.id == emptyId ? 'new' : 'changed'
							result.entityDescription = ''
							result.entityId = this.settings.transaction.id
							result.entityTotalAmount = this.settings.transaction.amount
							result.entityType = 'Transaction'
							result.factorHeaderId = result.factorHeader.id
							result.isInitial = false
							this.attachments.splice(this.selectedRow.displayOrder, 1, result)
						}
					})
					.catch(() => {
						this.$refs.table.$el.focus()
					})
			},
			clearForm() {
				this.attachments = []
			},
			deleteAttachment(button, e) {
				e.preventDefault()
				if (!this.selectedRow)
					return this.$toast(this.$t('document.m.select-row'))

				const selectedItem = this.attachments.find(x => x.id === this.selectedRow.id)
				if (selectedItem?.id.includes('emptyId'))
					this.attachments = this.attachments.filter(x => x.id !== selectedItem?.id)
				else {
					selectedItem.rowState = 'deleted'
					this.selectedRow.rowState = 'deleted'
				}
			},
			loadAttachments() {
				if (!this.settings.transaction || isEmpty(this.settings.transaction?.id)) {
					this.attachments = []
					return
				}
				var wait = this.$wait(this.grandParent)
				post(Endpoints.getUrl('sale.factor.attach.get-factor-attached-payments-byEntityId'), { EntityIds: [this.settings.transaction.id], EntityType: this.settings.targetForm === 'transfer' ? 'Transfer' : 'Transaction' }, null, { preventConcurrent: false })
					.then((result) => {
						wait.end()
						this.attachments = result.data.items
						for (var attach of this.attachments) {
							attach.temp = { init: attach.entityAttachedAmount, changes: 0 }
						}
					})
					.catch((error) => {
						if (wait)
							wait.end()
					})
			},
			commitTableChanges() {
				return new Promise((resolve, reject) => {
					this.$refs.table.commitChanges()
						.then((transactions) => {
							resolve(transactions)
						})
						.catch(invalidRows => {
							if ($.isArray(invalidRows)) {
								var rowNumbers = invalidRows.map((x, i) => x.rowNumber).join(',')

								dialog({
									title: this.$t('trs.pay.hybrid.m.save-title'),
									body: this.$t('document.m.save.error.rows', { rowNumbers }),
									type: 'error'
								}).finally(() => reject(new Error('invalid-rows')))
							}
						})
				})
			},
			getAttachments() {
				return this.attachments.map(x => { return { ...x, id: x.rowState === 'new' ? emptyId : x.id } })
			},
			initTable() {
				this.$refs.table.init(true)
			}
		}
	}
</script>
<style></style>
